export default __webpack_public_path__ + "static/media/stat_off.e961ed5f.svg";